const WebUrl = "https://pathwayz.sportzvillage.com/school/#/";
// const WebUrl = "https://sportingbharat.com/school_webpage/#/";


export default WebUrl; 
